import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { Injectable } from '@angular/core';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { SelectionRequestInfo } from '../vo/selection-request-info.model';

// レスポンス構造
interface GoodsCoop {
  SupplyPriceStandard: string;
  SupplyPriceSpecial1: string;
  SupplyPriceSpecial2: string;
  CostPriceStandard: string;
  CostPriceSpecial1: string;
  CostPriceSpecial2: string;
}

interface GetGoodsCoopResponse {
  GoodsCoop: GoodsCoop
}

/**
 * 商品会員生協情報取得サービス
 * @export GetGoodsCoopService
 * @class GetGoodsCoopService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetGoodsCoopService extends PlessJsonResponderSub<GetGoodsCoopResponse> {
  item: SelectionRequestInfo;
  private calbak: (data: any) => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetGoodsCoopService
   */
  private getBody(): PlessRequest {
    const searchObj = {
      getGoodsCoop: {
        condition: {
          PCode: this.item.pCode,
        },
      }
    }

    return new PlessRequest({ search: searchObj });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof GetGoodsCoopService
   */
  execute(item: SelectionRequestInfo, f?: (data: any) => void): void {
    this.item = item;
    if (f) this.calbak = f;
    this.send('KYMW70getGoodsCoop', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetGoodsCoopService
   */
  success(data: GetGoodsCoopResponse) {
    if (this.calbak) this.calbak(data);
  }

  /**
   * 業務エラー時のメソッド
   * @param errList サーバ受信データ
   * 機能独自の処理を行う場合、このメソッドをオーバーライドして処理を実装する。
   */
  public plessErrorHandler(errList: Object): void {
    super.plessErrorHandler(errList);
  }

  /**
   * 特殊なエラーが返ってきた場合に呼び出されるメソッド。<br/>
   * 機能独自のステータスコードを持つ場合、このメソッドをオーバーライドして処理を実装する。
   */
  public exceptionError(status: string, result: any): void {
    super.exceptionError(status, result);
  }
}
